import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useContent } from '../cms/ContentContext';
import { supabase, supabaseEnabled } from '../lib/supabase';

export default function Admin() {
  const { isOwner, setEditMode } = useContent();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const login = async (e) => {
    e.preventDefault();
    setError('');
    if (!supabaseEnabled) { setError('Content service not configured.'); return; }
    setBusy(true);
    const { error } = await supabase.auth.signInWithPassword({ email, password });
    setBusy(false);
    if (error) setError(error.message);
  };

  const startEditing = () => {
    setEditMode(true);
    navigate('/');
  };

  return (
    <div className="min-h-screen bg-[#061E35] flex items-center justify-center px-4 py-24">
      <div className="w-full max-w-md rounded-xl bg-white p-8 shadow-2xl">
        <h1 className="text-2xl font-bold text-[#061E35]">Boston Federal — Site Editor</h1>

        {isOwner ? (
          <div className="mt-6">
            <p className="text-sm text-slate-600">
              You’re logged in. Click below, then click any text or image on the site to edit it.
              Changes save and go live instantly.
            </p>
            <button
              onClick={startEditing}
              className="mt-5 w-full rounded-md bg-[#1FA8F5] px-4 py-3 text-sm font-semibold text-white hover:bg-[#0B8ED8]"
            >
              Start editing the site
            </button>
            <button
              onClick={() => supabase.auth.signOut()}
              className="mt-3 w-full rounded-md px-4 py-2 text-sm font-medium text-slate-500 hover:bg-slate-100"
            >
              Log out
            </button>
          </div>
        ) : (
          <form onSubmit={login} className="mt-6 space-y-4">
            <p className="text-sm text-slate-600">Sign in to edit your website content.</p>
            <input
              type="email"
              required
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full rounded-md border border-slate-300 p-3 text-sm focus:border-[#1FA8F5] focus:outline-none"
            />
            <input
              type="password"
              required
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full rounded-md border border-slate-300 p-3 text-sm focus:border-[#1FA8F5] focus:outline-none"
            />
            {error && <p className="text-sm text-red-600">{error}</p>}
            <button
              type="submit"
              disabled={busy}
              className="w-full rounded-md bg-[#1FA8F5] px-4 py-3 text-sm font-semibold text-white hover:bg-[#0B8ED8] disabled:opacity-60"
            >
              {busy ? 'Signing in…' : 'Sign in'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
